<template>
  <b-modal
    :id="modalId"
    :title="trans('event_source')"
    size="lg"
    no-enforce-focus
    hide-footer
    body-class="p-3"
    @shown="onShown"
    @hidden="onHidden"
  >
    <b-row>
      <b-col class="col-7">
        <b-form-group :label="trans('type')">
          <b-form-radio-group
            v-model="type"
            :options="typeOptions"
            :disabled="busy"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="shown && ['form', 'am_class'].indexOf(type) >= 0" :label="trans('form')">
          <form-dropdown
            :organization="organization"
            v-model="recipient_form_id"
            :placeholder="trans('choose_a_form')"
            mode="forms"
            :disabled="busy"
            @list="onSelectForm"
          ></form-dropdown>
          <b-form-text v-if="type == 'form' && !!dateQuestionOptions && dateQuestionOptions.length == 0">
            <span class="text-danger">
              {{ trans('calendar_import_form_no_date_questions') }}
            </span>
          </b-form-text>
          <b-form-text v-if="type == 'am_class' && !!classQuestionOptions && classQuestionOptions.length == 0">
            <span class="text-danger">
              {{ trans('calendar_import_form_no_class_questions') }}
            </span>
          </b-form-text>
        </b-form-group>

        <div v-if="type == 'form' && !!dateQuestionOptions && dateQuestionOptions.length > 0">
          <b-form-group :label="`${trans('event_date')} (${trans('question').toLowerCase()})`">
            <b-form-select
              v-model="date_question_id"
              size="sm"
              :options="dateQuestionOptions"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>

          <b-form-group :label="`${trans('event_name')} (${trans('question').toLowerCase()})`">
            <b-form-select
              v-model="title_question_id"
              size="sm"
              :options="titleQuestionOptions"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>

          <b-form-group :label="`${trans('event_details')} (${trans('question').toLowerCase()})`">
            <b-form-select
              v-model="subtitle_question_id"
              size="sm"
              :options="subtitleQuestionOptions"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>

          <b-form-group>
            <label class="d-block mb-1">
              <b-row>
                <b-col>
                  {{ trans('additional_information_in_popup') }}
                </b-col>
                <b-col class="col-auto">
                  <b-button variant="link" size="sm" class="text-muted" v-b-modal.page-calendar-edit-event-source-edit-event-calendar-form-popup-description>
                    <i class="fa fa-fw fa-edit"></i>
                  </b-button>
                </b-col>
              </b-row>
            </label>
            <p v-if="!popup_description" class="border p-2">
              <em>
                {{ trans('none') }}
              </em>
            </p>
            <div v-if="!!popup_description" v-html="popup_description" class="border p-2">
            </div>
          </b-form-group>
        </div>

        <div v-if="type == 'am_class' && !!classQuestionOptions && classQuestionOptions.length > 0">
          <p>{{ trans('classes_events') }}</p>
          <ul>
            <li v-for="(o, index) in classQuestionOptions" :key="'class_'+index">{{ o.text }}</li>
          </ul>
        </div>

        <div v-if="type == 'am_classes'">
          <b-form-group :label="trans('name')">
            <b-form-input v-model="name" :disabled="busy" />
          </b-form-group>
          <b-form-group :label="trans('classes')">
            <model-treeselect
              :organization="organization"
              :url="`/organization/${organization.id}/event/ll`"
              v-model="class_ids"
              :disabled="busy"
              :placeholder="trans('classes')"
            ></model-treeselect>
          </b-form-group>
        </div>

        <div v-if="type == 'locations'">
          <b-form-group :label="trans('name')">
            <b-form-input v-model="name" :disabled="busy" />
          </b-form-group>

          <b-form-group :label="trans('locations')">
            <model-treeselect
              :organization="organization"
              :url="`/organization/${organization.id}/location/list?per_page=500`"
              v-model="location_ids"
              :placeholder="trans('locations')"
              :disabled="busy"
            ></model-treeselect>
          </b-form-group>

          <b-form-group :label="`${trans('booking_type')} (${trans('filter').toLowerCase()})`">
            <booking-types-dropdown
              :organization="organization"
              v-model="booking_type_id"
              :disabled="busy"
              @booking_type="booking_type = $event"
              :all-booking-types="all_booking_types"
              @all-booking-types="all_booking_types = $event"
            ></booking-types-dropdown>
          </b-form-group>
        </div>
        <div v-if="allowPickColor">
          <b-row>
            <b-col>
              <b-form-group :label="`${trans('color')} ${type == 'locations' ? `(${trans('default').toLowerCase()})` : ''}`">
                <b-button
                  v-for="c in colors"
                  :key="c.color"
                  variant="none"
                  size="sm"
                  class="mr-2"
                  :style="`background-color: ${c.color};`"
                  @click="color = c.color"
                >
                  <i :class="`fa fa-fw ${c.color == color ? 'fa-check' : ''}`"></i>
                </b-button>
                <b-form-text v-if="type == 'locations'">
                  {{ trans('calendar_import_locactions_color_default_about') }}
                </b-form-text>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col class="col-auto pr-0 no-left-padding">
              <div>
                <b-form-group class="mb-0">
                  <color-picker v-model="custom_color" @input="updateColor"></color-picker>
                </b-form-group>
              </div>
            </b-col>
            <b-col class="pl-0">
              {{ trans('custom') }}
              <i :class="`fa fa-fw ${custom_color == color ? 'fa-check text-success' : ''}`"></i>
            </b-col>
          </b-row>
        </div>

        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
      </b-col>

      <b-col class="col-5">
        <b-row>
          <b-col>
            <label>{{ trans('events') }}</label>
            <b-button variant="link" size="sm" @click="onClickRefresh" :disabled="busy || !dateQuestionOptions || dateQuestionOptions.length == 0">
              <i :class="`fa fa-fw fa-${busy ? 'circle-notch fa-spin' : 'redo'}`"></i>
            </b-button>
          </b-col>
          <b-col class="col-auto">
            <b-button variant="link" size="sm" @click="onClickPrevEvent" :disabled="busy || event_index == 0 || events.length == 0">
              <i class="fa fa-fw fa-chevron-left"></i>
            </b-button>
            <span :class="events.length == 0 ? 'text-muted' : ''">
              {{ events.length > 0 ? (event_index+1) : event_index }} / {{ events.length }}
            </span>
            <b-button variant="link" size="sm" @click="onClickNextEvent" :disabled="busy || event_index >= events.length-1">
              <i class="fa fa-fw fa-chevron-right"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-card :style="`border-radius: 4px; color: #0f0f0f; ${!!event ? `border-color: ${color}; background-color: ${color}; color: ${textColor}` : ''}`">
          <div v-if="!!event">
            <strong class="d-block">{{ event.title }}</strong>
            <small class="d-block">{{ event.allDay ? dateRangeStr(event.start, event.end) : timeRangeStr(event.start, event.end) }}</small>
            <div v-if="!!event.extendedProps && !!event.extendedProps.subtitle" class="mt-1" v-html="event.extendedProps.subtitle"></div>
          </div>
        </b-card>
        <div v-if="!!event && canEditPopupDescription" class="mt-2">
          <small class="text-muted d-block">{{ trans('event_additional_information_in_popup') }}</small>
          <div v-if="!!event.extendedProps.description" class="border p-2">
            <div v-html="event.extendedProps.description"></div>
          </div>
          <div class="text-right my-2">
            <b-button variant="outline-primary" size="sm" class="py-0" @click="onClickEditPopupDescription">
              <small>
                <i class="fa fa-fw fa-edit"></i>
                {{ trans('edit') }}
              </small>
            </b-button>
          </div>
          <div v-if="canEditVisibility" class="mt-2">
            <b-form-group>
              <label :class="`text-${event.extendedProps.hidden ? 'muted' : 'success'}`">
                <i :class="`fa fa-fw fa-eye${event.extendedProps.hidden ? '-slash' : ''}`"></i>
                {{ trans(event.extendedProps.hidden ? 'event_is_hidden' : 'event_is_visible') }}
              </label>
              <b-button variant="outline-secondary" size="sm" class="py-0 ml-2" @click="onClickEventIsHidden">
                {{ trans(event.extendedProps.hidden ? 'show' : 'hide') }}
              </b-button>
            </b-form-group>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-4 border-top pt-3">
      <b-col>
        <b-button v-if="!!event_source && event_source.id !== null" variant="outline-danger" class="mr-2" @click="onClickDelete">
          {{ trans('delete') }}
        </b-button>
      </b-col>
      <b-col class="col-auto">
        <b-button variant="light" class="mr-2" @click="onClickCancel">
          {{ trans('cancel') }}
        </b-button>
        <b-button variant="branded" @click="onClickSave">
          {{ trans('save') }}
        </b-button>
      </b-col>
    </b-row>

    <html-textarea-modal
      id="page-calendar-edit-event-source-edit-event-calendar-description"
      :organization="organization"
      v-model="event_popup_description"
      show-insert-form-document
      :url="popupDescriptionUrl"
      attr="calendar_description"
      :label="trans('event_additional_information_in_popup')"
      @input="onSaveEventPopupDescription($event)"
    ></html-textarea-modal>
    <html-textarea-modal
      id="page-calendar-edit-event-source-edit-event-calendar-form-popup-description"
      :organization="organization"
      v-model="popup_description"
      :label="trans('additional_information_in_popup')"
      show-insert-form-document
      :placeholders="placeholders"
    ></html-textarea-modal>
  </b-modal>
</template>

<style>
  .no-left-padding .color-picker {
    padding-left: 0 !important;
  }
</style>

<script>
  import FormDropdown from './../list/ListDropdown'
  import HtmlTextareaModal from './../../../common/components/HtmlTextareaModal'
  import ModelTreeselect from './../../../common/components/ModelTreeselect'
  import BookingTypesDropdown from './../booking-type/BookingTypesDropdown'
  import ColorPicker from './../../../common/components/ColorPicker'

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      event_source: Object,
      modalId: {
        type: String,
        default: 'page-calendar-edit-event-source-modal',
      },
    },
    components: {
      FormDropdown,
      HtmlTextareaModal,
      ModelTreeselect,
      BookingTypesDropdown,
      ColorPicker
    },
    data() {
      return {
        trans: trans,
        dateRangeStr: _.dateRangeStr,
        timeRangeStr: _.timeRangeStr,
        placeholders: _.getGroupedPlaceholdersForFormAnswers(),
        shown: false,
        busy: false,
        error: null,
        id: null,
        type: 'form', // form or am_class
        typeOptions: [
          {value: 'form', text: trans('calendar_import_form_about')},
          {value: 'am_class', text: trans('calendar_import_am_class_about')},
          {value: 'am_classes', text: trans('calendar_import_am_classes_about')},
          {value: 'locations', text: trans('calendar_import_locactions_about')},
        ],
        name: null,
        recipient_form_id: null,
        date_question_id: null,
        title_question_id: null, // title
        subtitle_question_id: null, // subtitle
        recipient_form: null,
        location_ids: null,
        class_ids: null,
        booking_type_id: null,
        booking_type: null,
        all_booking_types: null,
        events: [],
        event_index: 0,
        color: '#B8DCEE',
        colors: _.calendarColors,
        last_url: null,
        popup_description: null, // for all events in the event source (only supported for date questions)
        event_popup_description: null, // for a specific event
        custom_color: '#22b24c'
      }
    },
    computed: {
      allowPickColor() {
        return this.type == 'form' && !!this.dateQuestionOptions && this.dateQuestionOptions.length > 0 ||
          this.type == 'am_class' && !!this.classQuestionOptions && this.classQuestionOptions.length > 0 ||
          this.type == 'am_classes' ||
          this.type == 'locations' && !!this.location_ids && this.location_ids.length > 0 && !this.booking_type
      },
      serialized() {
        return {
          id: this.id,
          type: this.type,
          name: this.name,
          recipient_form_id: this.recipient_form_id,
          date_question_id: this.type == 'form' ? this.date_question_id : null,
          title_question_id: this.type == 'form' ? this.title_question_id : null,
          subtitle_question_id: this.type == 'form' ? this.subtitle_question_id : null,
          location_ids: this.type == 'locations' ? this.location_ids : null,
          class_ids: this.type == 'am_classes' ? this.class_ids : null,
          booking_type_id: this.type == 'locations' ? this.booking_type_id : null,
          color: this.color,
          popup_description: this.popup_description,
        }
      },
      dateQuestionOptions() {
        if (!this.recipient_form || !this.recipient_form.new_form) return null
        return _.reduce(this.recipient_form.new_form.form_questions || [], (questions, q) => {
          if (['date_selection', 'time_track'].indexOf(q.type) >= 0 ||
            ['date', 'admin_date', 'date_range'].indexOf(q.type) >= 0 && q.options.control != 'time')
            questions.push({value: q.id, text: q.label})
          return questions
        }, [])
      },
      titleQuestionOptions() {
        if (!this.recipient_form || !this.recipient_form.new_form) return null
        return _.reduce(this.recipient_form.new_form.form_questions || [], (questions, q) => {
          if (['date', 'admin_date', 'date_range', 'date_selection', 'time_track', 'account_owner', 'input', 'select', 'admin_select', 'radios', 'notify'].indexOf(q.type) >= 0)
            questions.push({value: q.id, text: q.label})
          return questions
        }, [])
      },
      subtitleQuestionOptions() {
        if (!this.recipient_form || !this.recipient_form.new_form) return null
        return _.reduce(this.recipient_form.new_form.form_questions || [], (questions, q) => {
          if (['account_owner', 'input', 'admin_note', 'select', 'admin_select', 'radios', 'notify'].indexOf(q.type) >= 0)
            questions.push({value: q.id, text: q.label})
          return questions
        }, [])
      },
      classQuestionOptions() {
        if (!this.recipient_form || !this.recipient_form.new_form) return null
        return _.reduce(this.recipient_form.new_form.form_questions || [], (questions, q) => {
          if (['event_block', 'ticket_block', 'events_block'].indexOf(q.type) >= 0)
            questions.push({value: q.id, text: q.label})
          return questions
        }, [])
      },
      event() {
        if (this.events.length == 0) return null
        return this.events[this.event_index] ?? null
      },
      canEditPopupDescription() {
        if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return false
        return !!this.event.extendedProps && ['date', 'date_range', 'time_track', 'booking'].indexOf(this.event.extendedProps.type) >= 0 ||
          this.event.extendedProps.type == 'am_class' && this.type == 'am_classes'
      },
      canEditVisibility() {
        if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return false
        return !!this.event.extendedProps && ['date', 'date_range', 'time_track'].indexOf(this.event.extendedProps.type) >= 0
      },
      popupDescriptionUrl() {
        if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return null
        if (['date', 'date_range', 'time_track'].indexOf(this.event.extendedProps.type) >= 0)
          return `/organization/${this.organization.id}/checkout_form/${this.event.extendedProps.form_id}/answer/${this.event.extendedProps.answer_id}/calendar_description`
        if (this.event.extendedProps.type == 'am_class')
          return `/organization/${this.organization.id}/event/${this.event.extendedProps.am_class_id}/event/${this.event.id}/calendar_description`
        if (this.event.extendedProps.type == 'booking')
          return `/organization/${this.organization.id}/booking/${this.event.extendedProps.booking_id}/event/${this.event.extendedProps.event_id}/calendar_description`
      },
      textColor() {
        return _.hexContrastColor(this.color)
      }
    },
    watch: {
      dateQuestionOptions() {
        if (!!this.dateQuestionOptions && !this.date_question_id && this.dateQuestionOptions.length > 0)
          this.date_question_id = this.dateQuestionOptions[0].id
      },
      type() {
        this.last_url = null
      },
      date_question_id() {
        this.last_url = null
      },
      title_question_id() {
        this.last_url = null
      },
      subtitle_question_id() {
        this.last_url = null
      },
      location_ids() {
        this.last_url = null
      },
      booking_type_id() {
        this.last_url = null
      },
      booking_type() {
        if (this.booking_type) this.color = this.booking_type.background_color
      },
      serialized() {
        this.maybeFetchEvents()
      },
    },
    methods: {
      onClickPrevEvent() {
        if (this.event_index > 0) this.event_index -= 1
      },
      onClickNextEvent() {
        if (this.event_index < this.events.length-1) this.event_index += 1
      },
      onClickDelete() {
        this.$bvModal.msgBoxConfirm(trans('delete_confirm'), {
          title: trans('delete'),
          okTitle: trans('delete'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          this.$emit('delete', this.serialized)
          this.$bvModal.hide(this.modalId)
        })
      },
      onClickEditPopupDescription() {
        if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return
        if (this.event.extendedProps.type == 'am_class')
          this.event_popup_description = this.event.extendedProps.calendar_description
        else
          this.event_popup_description = this.event.extendedProps.description
        this.$bvModal.show('page-calendar-edit-event-source-edit-event-calendar-description')
      },
      onSaveEventPopupDescription(description) {
        this.onClickRefresh()
      },
      onClickEventIsHidden() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/checkout_form/${this.event.extendedProps.form_id}/answer/${this.event.extendedProps.answer_id}/calendar_hidden`
        axios.patch(url, {calendar_hidden: !this.event.extendedProps.hidden})
        .then(response => {
          this.busy = false
          this.onClickRefresh()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickSave() {
        this.$emit('save', this.serialized)
        this.$bvModal.hide(this.modalId)
      },
      onClickCancel() {
        this.$bvModal.hide(this.modalId)
      },
      onShown() {
        this.id = this.event_source.id
        this.type = this.event_source.type || 'form'
        this.name = this.event_source.name
        this.recipient_form_id = this.event_source.recipient_form_id
        this.date_question_id = this.event_source.date_question_id
        this.title_question_id = this.event_source.title_question_id
        this.subtitle_question_id = this.event_source.subtitle_question_id
        this.location_ids = this.event_source.location_ids || null
        this.class_ids = this.event_source.class_ids || null
        this.booking_type_id = this.event_source.booking_type_id || null
        this.color = this.event_source.color || '#B8DCEE'
        this.popup_description = this.event_source.popup_description || null
        this.custom_color = !_.includes(_.map(this.colors, c => c.color), this.event_source?.color) ? this.event_source.color : '#22b24c'
        this.shown = true
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.events = []
        this.event_index = 0
        this.last_url = null
        this.recipient_form_id = null
        this.recipient_form = null
        this.date_question_id = null
        this.title_question_id = null
        this.subtitle_question_id = null
        this.location_ids = null
        this.class_ids = null
        this.booking_type_id = null
        this.color = '#B8DCEE'
        this.popup_description = null
        this.shown = false
      },
      onSelectForm(recipient_form) {
        if (this.recipient_form && this.recipient_form.id == recipient_form.id) return
        this.recipient_form = recipient_form
        this.recipient_form_id = recipient_form.id
        this.name = recipient_form.name
        this.fetchForm()
      },
      fetchForm() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/checkout_form/${this.recipient_form.form_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.$set(this.recipient_form, 'new_form', response.data)
          this.maybeFetchEvents()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickRefresh() {
        this.last_url = null
        this.maybeFetchEvents()
      },
      maybeFetchEvents() {
        if (['form', 'am_class'].indexOf(this.type) >= 0 && !this.recipient_form_id ||
          this.type == 'form' && (!this.dateQuestionOptions || this.dateQuestionOptions.length == 0 || !this.date_question_id || !this.title_question_id) ||
          this.type == 'am_class' && (!this.classQuestionOptions || this.classQuestionOptions.length == 0) ||
          this.type == 'locations' && (!this.location_ids || this.location_ids.length == 0) ||
          this.type == 'am_classes' && (!this.class_ids || this.class_ids.length == 0)) {
          this.events = []
          this.event_index = 0
          this.last_url = null
          return
        }
        let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_calendar_events`
        if (url == this.last_url) return
        this.busy = true
        this.error = null
        let block = _.cloneDeep(this.block)
        block.meta.event_sources = [this.serialized]
        axios.post(url, block)
        .then(response => {
          this.busy = false
          this.events = response.data
          this.last_url = url
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      updateColor(e) {
        this.color = e
      }
    },
    mounted() {
      window.pageCalendarEditEventSourceModal = this
    },
  }
</script>
